var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',[(_vm.fuel)?_c('li',[_vm._v(_vm._s(_vm.fuel))]):_vm._e(),(_vm.transmission)?_c('li',[_vm._v(_vm._s(_vm.transmission))]):_vm._e(),(_vm.traction)?_c('li',[_vm._v(_vm._s(_vm.traction))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }